const TABKEY = 9;
const BACKSPACE = 8;
const DELETE = 46;
const LEFTARROW = 37;
const RIGHTARROW = 39;
const allowedKeys = [TABKEY, BACKSPACE, LEFTARROW, RIGHTARROW, DELETE];

const isDigit = (key: string) => key >= "0" && key <= "9";

export const usePreventNonNumeric = (max: number) => {
  const onKeyDown = (event: KeyboardEvent) => {
    const selectedArea = document.getSelection();
    var selectedText = selectedArea ? selectedArea.toString() : "";

    const currentValue =
      event && event.target && (<HTMLInputElement>event.target).value
        ? (<HTMLInputElement>event.target).value
        : "";

    if (isDigit(event.key)) {
      if (selectedText.length !== currentValue.length) {
        const futureValue = Number(currentValue + event.key);
        if (futureValue > max) {
          event.preventDefault();
        } else if (currentValue === "0" && event.key === "0") {
          event.preventDefault();
        }
      }
    } else {
      if (!allowedKeys.includes(event.keyCode)) {
        event.preventDefault();
      }
    }
  };

  return {
    onKeyDown
  };
};
